module.exports = __webpack_public_path__ + "static/gdmc_logo-fe628f88adf05938d139eb48def5368d.svg";